import { createAction, props } from '@ngrx/store';
import { BizProduct } from '../../models/biz-product.model';


export const loadBizShopProducts = createAction(
  '[Shop Product] Load Biz Shop Products',
  props<{ categoryId: any, subCategoryId: any, adminId: any, search: any, page: any, limit: any }>()
);
export const loadBizShopProductsSuccess = createAction(
  '[Shop Product] Load Biz Shop Products Success',
  props<{ bizShopProducts:{ currentPage: number, data: BizProduct[], nextPage: number, pageSize: number, prevPage: number, totalItems: number, totalPages: number } }>()
);
export const loadBizShopProductsFailure = createAction(
  '[Shop Product] Load Biz Shop Products Failure',
  props<{ error: any }>()
);
